import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import ProjectApi from "../../api/projectApi";
import BugApi from "../../api/BugApi";

function BugsList() {
  const navigate = useNavigate();

  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchBugProjects = async () => {
    try {
      setLoading(true);

      const projectRes =
        await ProjectApi.assignedTestingProjects();

      console.log(
        "BUG PROJECT RESPONSE:",
        projectRes
      );

      if (projectRes?.code !== 200) {
        console.error(
          "PROJECT API FAILED:",
          projectRes
        );

        setProjects([]);
        return;
      }

      const projectData =
        projectRes?.data?.projects ||
        projectRes?.data ||
        [];

      if (!Array.isArray(projectData)) {
        console.error(
          "PROJECT DATA IS NOT ARRAY:",
          projectData
        );

        setProjects([]);
        return;
      }

      const projectsWithBugStats =
        await Promise.all(
          projectData.map(async (project) => {
            try {
              const bugRes =
                await BugApi.getProjectBugs(
                  project?._id
                );

              console.log(
                "PROJECT BUGS:",
                project?._id,
                bugRes
              );

              /*
                HANDLE MULTIPLE RESPONSE STRUCTURES
              */

              let bugList = [];

              if (
                Array.isArray(
                  bugRes?.data?.bugs
                )
              ) {
                bugList =
                  bugRes.data.bugs;
              } else if (
                Array.isArray(
                  bugRes?.bugs
                )
              ) {
                bugList =
                  bugRes.bugs;
              } else if (
                Array.isArray(
                  bugRes?.data
                )
              ) {
                bugList =
                  bugRes.data;
              } else if (
                Array.isArray(
                  bugRes?.data?.data?.bugs
                )
              ) {
                bugList =
                  bugRes.data.data.bugs;
              } else if (
                Array.isArray(
                  bugRes?.data?.data
                )
              ) {
                bugList =
                  bugRes.data.data;
              }

              console.log(
                "FINAL BUG LIST:",
                project?.projectName,
                bugList
              );

              const total =
                bugList.length;

              const open =
                bugList.filter(
                  (bug) =>
                    bug?.status === "open"
                ).length;

              const fixed =
                bugList.filter(
                  (bug) =>
                    bug?.status === "fixed"
                ).length;

              const closed =
                bugList.filter(
                  (bug) =>
                    bug?.status === "closed"
                ).length;

              const reopened =
                bugList.filter(
                  (bug) =>
                    bug?.status === "reopened"
                ).length;

              const critical =
                bugList.filter(
                  (bug) =>
                    bug?.severity === "critical"
                ).length;

              return {
                ...project,

                bugStats: {
                  total,
                  open,
                  fixed,
                  closed,
                  reopened,
                  critical,
                },
              };
            } catch (error) {
              console.error(
                "PROJECT BUG STATS ERROR:",
                project?._id,
                error
              );

              return {
                ...project,

                bugStats: {
                  total: 0,
                  open: 0,
                  fixed: 0,
                  closed: 0,
                  reopened: 0,
                  critical: 0,
                },
              };
            }
          })
        );

      console.log(
        "FINAL PROJECTS WITH BUG STATS:",
        projectsWithBugStats
      );

      setProjects(
        projectsWithBugStats
      );
    } catch (error) {
      console.error(
        "FETCH BUG PROJECT ERROR:",
        error
      );

      setProjects([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBugProjects();
  }, []);

  if (loading) {
    return (
      <div className="content">
        <div className="text-center py-5">
          Loading Bug Management...
        </div>
      </div>
    );
  }

  return (
    <div className="content">

      {/* HEADER */}

      <div className="d-flex justify-content-between align-items-center mb-4">

        <div>

          <h3 className="fw-bold mb-1">
            🐞 Bug Management
          </h3>

          <p className="text-muted mb-0">
            Track, manage and resolve reported bugs
          </p>

        </div>

        <button
          type="button"
          className="btn btn-outline-danger"
          onClick={fetchBugProjects}
        >
          ↻ Refresh
        </button>

      </div>


      {/* EMPTY STATE */}

      {projects.length === 0 ? (

        <div className="card border-0 shadow-sm">

          <div className="card-body text-center py-5">

            <div
              style={{
                fontSize: "55px",
                marginBottom: "15px",
              }}
            >
              🐞
            </div>

            <h5 className="fw-bold">
              No Projects Available
            </h5>

            <p className="text-muted mb-0">
              No projects are currently available
              for bug management.
            </p>

          </div>

        </div>

      ) : (

        <div className="card border-0 shadow-sm">

          <div className="card-body p-0">

            <div className="table-responsive">

              <table className="table table-hover align-middle mb-0">

                <thead className="table-light">

                  <tr>

                    <th className="ps-4">
                      Project
                    </th>

                    <th>
                      Total Bugs
                    </th>

                    <th>
                      Open
                    </th>

                    <th>
                      Fixed
                    </th>

                    <th>
                      Closed
                    </th>

                    <th>
                      Critical
                    </th>

                    <th className="text-end pe-4">
                      Action
                    </th>

                  </tr>

                </thead>

                <tbody>

                  {projects.map(
                    (project) => {
                      const stats =
                        project?.bugStats || {};

                      return (

                        <tr
                          key={project?._id}
                        >

                          {/* PROJECT */}

                          <td className="ps-4">

                            <div className="fw-bold">
                              {project?.projectName ||
                                "-"}
                            </div>

                            <small className="text-muted">

                              Developer:{" "}

                              {project?.assignedDeveloper
                                ?.name || "-"}

                            </small>

                          </td>


                          {/* TOTAL */}

                          <td>

                            <strong>
                              {stats?.total || 0}
                            </strong>

                          </td>


                          {/* OPEN */}

                          <td>

                            <span className="badge bg-danger px-3 py-2">

                              {stats?.open || 0}

                            </span>

                          </td>


                          {/* FIXED */}

                          <td>

                            <span className="badge bg-primary px-3 py-2">

                              {stats?.fixed || 0}

                            </span>

                          </td>


                          {/* CLOSED */}

                          <td>

                            <span className="badge bg-success px-3 py-2">

                              {stats?.closed || 0}

                            </span>

                          </td>


                          {/* CRITICAL */}

                          <td>

                            {stats?.critical > 0 ? (

                              <span className="badge bg-dark px-3 py-2">

                                ⚠ {stats?.critical}

                              </span>

                            ) : (

                              <span className="text-muted">
                                0
                              </span>

                            )}

                          </td>


                          {/* ACTION */}

                          <td className="text-end pe-4">

                            <button
                              type="button"
                              className="btn btn-danger btn-sm px-3"
                              onClick={() =>
                                navigate(
                                  `/bugs/${project?._id}`
                                )
                              }
                            >
                              🐞 Manage Bugs
                            </button>

                          </td>

                        </tr>
                      );
                    }
                  )}

                </tbody>

              </table>

            </div>

          </div>

        </div>

      )}

    </div>
  );
}

export default BugsList;